var _rect, _rect2, _path, _path2, _path3, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleBar1KmNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 24,
    viewBox: "0 0 442 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 442,
    height: 24,
    rx: 5,
    fill: "#282B2D",
    fillOpacity: 0.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8555,
    y: 9.03638,
    width: 1.48182,
    height: 5.92727,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3379 13.4818L199.574 13.4818V14.9636L13.3379 14.9636V13.4818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.623 6.99219V17H209.358V8.57129L206.809 9.50098V8.35938L210.425 6.99219H210.623ZM219.223 6.5V17H217.951V6.5H219.223ZM223.741 9.60352L220.515 13.0557L218.71 14.9287L218.607 13.582L219.899 12.0371L222.196 9.60352H223.741ZM222.586 17L219.947 13.4727L220.604 12.3447L224.076 17H222.586ZM226.305 11.0732V17H225.033V9.60352H226.236L226.305 11.0732ZM226.045 13.0215L225.457 13.001C225.462 12.4951 225.528 12.028 225.655 11.5996C225.783 11.1667 225.972 10.7907 226.223 10.4717C226.473 10.1527 226.785 9.90658 227.159 9.7334C227.533 9.55566 227.966 9.4668 228.458 9.4668C228.804 9.4668 229.123 9.51693 229.415 9.61719C229.707 9.71289 229.96 9.86556 230.174 10.0752C230.388 10.2848 230.554 10.5537 230.673 10.8818C230.791 11.21 230.851 11.6064 230.851 12.0713V17H229.586V12.1328C229.586 11.7454 229.52 11.4355 229.388 11.2031C229.26 10.9707 229.078 10.8021 228.841 10.6973C228.604 10.5879 228.326 10.5332 228.007 10.5332C227.633 10.5332 227.321 10.5993 227.07 10.7314C226.82 10.8636 226.619 11.0459 226.469 11.2783C226.318 11.5107 226.209 11.7773 226.141 12.0781C226.077 12.3743 226.045 12.6888 226.045 13.0215ZM230.837 12.3242L229.989 12.584C229.994 12.1784 230.06 11.7887 230.188 11.415C230.32 11.0413 230.509 10.7087 230.755 10.417C231.006 10.1253 231.313 9.89518 231.678 9.72656C232.042 9.55339 232.459 9.4668 232.929 9.4668C233.325 9.4668 233.676 9.51921 233.981 9.62402C234.291 9.72884 234.551 9.89062 234.761 10.1094C234.975 10.3236 235.137 10.5993 235.246 10.9365C235.355 11.2738 235.41 11.6748 235.41 12.1396V17H234.139V12.126C234.139 11.7113 234.073 11.39 233.94 11.1621C233.813 10.9297 233.631 10.7679 233.394 10.6768C233.161 10.5811 232.883 10.5332 232.56 10.5332C232.282 10.5332 232.035 10.5811 231.821 10.6768C231.607 10.7725 231.427 10.9046 231.281 11.0732C231.135 11.2373 231.024 11.4264 230.946 11.6406C230.873 11.8548 230.837 12.0827 230.837 12.3242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.428 13.4818L428.664 13.4818V14.9636L242.428 14.9636V13.4818Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 428.664,
    y: 9.03638,
    width: 1.48182,
    height: 5.92727,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleBar1KmNew);
export default __webpack_public_path__ + "static/media/scaleBar1KmNew.b2d53869617f2e44361afcc8fcf90a0c.svg";
export { ForwardRef as ReactComponent };